import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Pencil = function Pencil(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.181 1.5567l2.3189 2.4133c0.37727 0.39263 0.37106 1.0149-0.013964 1.4l-11.662 11.662c-0.39052 0.39052-1.0237 0.39052-1.4142 0-0.0033467-0.0033467-0.0066697-0.0067172-0.0099685-0.010111l-2.3284-2.3955c-0.38099-0.39196-0.37666-1.0172 0.009719-1.4039l11.672-11.68c0.39039-0.39066 1.0236-0.39089 1.4142-4.9924e-4 0.0047867 0.0047833 0.0095247 0.0096151 0.014213 0.014495zm-14.522 13.895l2.6996 2.8568c0.18966 0.20071 0.18071 0.51716-0.019998 0.70682-0.031368 0.029642-0.066442 0.055098-0.10435 0.075733l-5.7682 3.1402c-0.24253 0.13203-0.54618 0.042454-0.67821-0.20008-0.078976-0.14507-0.081209-0.31979-0.0059666-0.46683l3.0687-5.997c0.12579-0.24583 0.42705-0.34314 0.67287-0.21735 0.050675 0.02593 0.09655 0.060324 0.13565 0.1017zm0.8407 6.1487h15c0.27614 0 0.5 0.22386 0.5 0.5s-0.22386 0.5-0.5 0.5h-15c-0.27614 0-0.5-0.22386-0.5-0.5s0.22386-0.5 0.5-0.5z"
  })));
};

Pencil.displayName = 'Pencil';
export default Pencil;